// If a message's eventType matches one of these, it is a notification
const NOTIFICATION_TYPES = [
  'roomInvite',
  'pinsResponse'
]
const ROOM_GUEST_TYPES = [
  'userEntersLobby',
  'userLeftLobby',
  'hostAcceptedUserInLobby',
  'hostDeclinedUserInLobby'
]

const actions = {
  async handleConnectionMessage({rootGetters, commit, dispatch}, message) {
    let event = JSON.parse(message);
    console.log('MESSAGE QUEUE', event)

    if (event.eventType === 'shutdown') {
      console.log('shutdown - multiple tabs open', event);
      commit('api/auth/FORCED_SHUTDOWN', true, {root: true});
      dispatch('multipleTabRedirect', null, {root: true});
      let connection = rootGetters['api/connection/connection']
      await connection.stop();
    } else if (event.eventType === 'error') {
      console.log('error: ', event.data.message);
    } else {
      // if (this.enableEventLogging) {
      // console.log('location: ',event)
      //   this.messageList.push(event.at + " > " + event.eventType)
      // }
      if (event.eventType === 'locationUpdated') {
        dispatch('updateLocation', [event.data, true], {root: true});
      } else if(event.eventType === 'participantsUpdated') {
        dispatch('search/handleSpaceParticipantsUpdate', event.data, {root: true})
      } else if (event.eventType === 'chatMessage') {
        dispatch('updateChatFeed', { data: event.data }, {root: true});
      } else if (event.eventType === 'chatDelete') {
        dispatch('removeMessageFromChatFeed', { data: event }, {root: true});
      } else if (event.eventType === 'chatClear') {
        dispatch('clearChatFeed', { data: event }, {root: true});
      } else if (event.eventType === 'chatReaction') {
        dispatch('updateChatMessageReactions', { data: event }, {root: true});
      } else if (NOTIFICATION_TYPES.includes(event.eventType)) {
        dispatch('handleNotificationUpdate', event.data, {root: true})
      } else if (event.eventType === 'broadcast') {
        dispatch('showBroadcast', event.data, {root: true});
      } else if (event.eventType === 'notificationUpdate') {
        dispatch('handleNotificationUpdate', event.data, {root: true});
      } else if (event.eventType === 'broadcastDelete') {
        dispatch('handleBroadcastDeleted', event.data, {root: true});
      } else if (event.eventType == 'spaceInvite' || event.eventType == 'roomInviteResponse') {
        dispatch('fetchPendingInviteAreas', null, {root: true})
      } else if (event.eventType == 'userKickedOutFromSpace') {
        dispatch('handleKickedFromRoom', event.data, {root: true})
      } else if (event.eventType == 'hostPromote') {
        dispatch('handleMadeCohost', event.data, {root: true})
      } else if (ROOM_GUEST_TYPES.includes(event.eventType)) {
        dispatch('guest/room/handleRoomGuestUpdate', [event.eventType, event.data], {root: true})
      } else {
        console.warn("Unknown event type:", event);
      }
    }
  }
}

export default {
	namespaced: true,
  actions
};
